import axios from 'axios';

export function logError(error, info = '', description = 'None') {
  const token = localStorage.getItem('SessionToken');
  return axios({
    method: 'POST',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/log/error/`,
    headers: {
      Authorization: `Token ${token}`,
    },
    data: {
      error: JSON.stringify(error.toString()),
      info,
      description,
      token,
    },
  });
}
